import { SendStream } from '../components/util/SendStream'

export class SendToRequest {

    receiversList : any[]
    initialValueOfUnsentEmails : number
    isBackup : boolean
    stream : SendStream

    constructor(receiversList : any[], 
        initialValueOfUnsentEmails : number, 
        isBackup : boolean,
        stream : SendStream) {

            this.receiversList = receiversList
            this.initialValueOfUnsentEmails = initialValueOfUnsentEmails
            this.isBackup = isBackup
            this.stream = stream
        }

}